import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const PrivateRoute = ({ children }) => {
  const { user } = useUser();
  const isLoggedIn = !!user;
  const location = useLocation();

  if (!isLoggedIn) {
    // Redirect to login and preserve the path they were trying to access
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};

export default PrivateRoute;
